import React, { useEffect, useRef, useState } from "react";
import "./style.css";

export const GNavbar = ({ searchTerm, onSearchChange }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearch = (event) => {
    if (onSearchChange) {
      onSearchChange(event.target.value);
    }
  };

  return (
    <nav className="gallery-navbar">
      <div className="gallery-navbar__left">
        <div className="gallery-logo" aria-label="Sololine">
          <img
            src="/logo-blue-sololine.png"
            alt="Sololine"
            className="gallery-logo__image"
          />
        </div>
      </div>
      <div className="gallery-navbar__search">
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Buscar"
        />
      </div>
      <div className="gallery-navbar__right" ref={menuRef}>
        <button
          type="button"
          className="gallery-menu-toggle"
          onClick={toggleMenu}
          aria-label="Abrir menú"
        >
          <span className="gallery-menu-toggle__label">B</span>
        </button>
        {menuOpen && (
          <div className="profile-menu">
            <ul>
              <li>Pagos</li>
              <li>Configuración</li>
              <li>Cerrar sesión</li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default GNavbar;
